import { calcColorStateOrdenTrabajoNew, humanizeName } from '@/shared';
import { EstadoComponente } from '@/shared/components/ui';

export type EstadoOTNewTableCellProps = {
  codigo: string;
  nombre: string;
};

const EstadoOTNewTableCell: React.FC<EstadoOTNewTableCellProps> = ({
  codigo,
  nombre,
}) => {
  return (
    <>
      <EstadoComponente
        backgroundColor={calcColorStateOrdenTrabajoNew(codigo)}
        texto={humanizeName(nombre)}
      />
    </>
  );
};

export default EstadoOTNewTableCell;
